<template>
  <Select
    :items="tipos"
    :selectedItem="filter.tipo"
    label="Tipo"
    searchPlaceholder="Buscar tipo"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        tipo: {
          id: "",
          name: "",
        },
      },
      tipos: [
        { id: "0", name: "Entrada" },
        { id: "1", name: "Saída" }
      ],
    };
  },
  methods: {
    atualizar(tipo) {
      this.filter.tipo = tipo;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.tipo.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.tipo.id
      });
    },
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.tipos, this.filter.tipo);
  }
}
</script>
